<template>
    <div class="page">
        <div class="header">
            <div class="btns">
                <el-button size="mini" @click="getData" icon="el-icon-refresh">刷新</el-button>
            </div>
            <el-page-header @back="$router.go(-1)" content="五高问卷"/>
        </div>
        <div class="search">
            <el-form :inline="true" :model="search" size="small" label-width="70px">
                <el-form-item label="工作单位">
                    <cascader-company-name v-model="search.companyName"></cascader-company-name>
                </el-form-item>
                <el-form-item label="搜索" label-width="40px">
                    <el-input placeholder="请输入内容" v-model="search.value" class="input-with-select" clearable>
                        <el-select v-model="search.key" slot="prepend" placeholder="请选择" style="width:90px">
                            <el-option label="名称" value="name"></el-option>
                            <el-option label="身份证" value="idCard"></el-option>
                            <el-option label="手机号" value="mobile"></el-option>
                            <el-option label="单位" value="companyName"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item label="激活状态">
                    <el-select v-model="search.activeStatus" placeholder="请选择" style="width:130px" clearable>
                        <el-option label="全部" value="全部"></el-option>
                        <el-option label="未激活" value="0"></el-option>
                        <el-option label="已激活" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="问卷发送时间" label-width="100px">
                    <el-date-picker v-model="search.questionnaireTime" type="daterange" range-separator="至" clearable
                                    start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="回填状态">
                    <el-select v-model="search.questionnaireStatus" placeholder="请选择" style="width:100%" clearable>
                        <el-option label="未发送" value="0"></el-option>
                        <el-option label="已发送未填写" value="1"></el-option>
                        <el-option label="已填写" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="风险人群" label-width="70px">
                    <el-select v-model="search.risklevel" placeholder="请选择" style="width:100%" clearable>
                        <el-option label="健康人群" value="健康人群"></el-option>
                        <el-option label="风险人群" value="风险人群"></el-option>
                        <el-option label="异常人群" value="异常人群"></el-option>
                        <el-option label="慢病人群" value="慢病人群"></el-option>
                        <el-option label="大病人群" value="大病人群"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="人群等级" label-width="70px">
                    <el-select v-model="search.level" placeholder="请选择" style="width:100%" filterable allow-create
                               default-first-option clearable>
                        <el-option label="全部" value="全部"></el-option>
                        <el-option :label="item.name" :value="item.name" v-for="(item, index) in tagList"
                                   :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="指标等级" label-width="70px">
                    <el-cascader :options="dbList" :props="defaultProps" collapse-tags clearable
                                 v-model="search.risklevelList"></el-cascader>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" plain @click="getData" v-has="'fivehighs_search'">查询</el-button>
                    <el-button type="" plain @click="reset" v-has="'fivehighs_search'">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="search" style="background-color: #fff">
            <div class="btns">
                <el-button type="primary" size="mini" @click="handleSendQuestionnaire" :disabled="idList.length?false:true" v-has="'fivehighs_send'">
                    发送五高问卷
                </el-button>
            </div>
        </div>
        <div class="main-content">
            <div class="table-content">
                <el-table :data="table.data" stripe size="mini" border v-loading="loading" width="100%"
                          height="100%"
                          @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                    <el-table-column type="index" label="序号" align="center"
                                     :index="(index) => { return (this.table.page - 1) * this.table.pageSize + index + 1 }"
                                     width="55"/>
                    <el-table-column align="center" label="基本信息" width="">
                        <template slot-scope="scope">
                            <div>
                                <span>{{ scope.row.name }}</span>
                                <span v-if="scope.row.sex=='2'"> 女 </span>
                                <span v-if="scope.row.sex=='1'"> 男 </span>
                                <span v-if="scope.row.age">{{scope.row.age }} 岁</span>
                            </div>
                            <div>
                                <small> {{ isFullIdCard[scope.$index] ? scope.row.idCard :
                                    maskIdCardRegex(scope.row.idCard) }}</small>
                                <i class="el-icon-view" style="cursor: pointer;padding-left: 10px"
                                   @click="toggleIdCard(scope.$index)"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="客户标签" width="100">
                        <template slot-scope="scope">
                            <popover-JCXM :tagList="scope.row"/>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="联系方式" width="">
                        <template slot-scope="scope">
                            <div>
                                <span v-if="scope.row.entOrgNameTwo">{{scope.row.entOrgNameTwo}}</span>
                                <span v-if="scope.row.entOrgNameThree"> | {{scope.row.entOrgNameThree}}</span>
                                <span v-if="scope.row.entOrgNameFour"> | {{scope.row.entOrgNameFour}}</span>
                                <span v-if="scope.row.entOrgNameFive"> | {{scope.row.entOrgNameFive}}</span>
                            </div>
                            <div>{{ scope.row.mobile }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="单位分组" width="">
                        <template slot-scope="scope">
                            <div>{{ scope.row.wpName }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="最近回填" prop="questionnaireStatus" width="130">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.questionnaire_status === '2'" type="success">已填写</el-tag>
                            <el-tag v-else-if="scope.row.questionnaire_status === '1'" type="warning">已发送未填写</el-tag>
                            <el-tag v-else type="info">未发送</el-tag>
                            <div v-if="scope.row.questionnaire_time">发送时间：{{scope.row.questionnaire_time|datetime}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="240" label="操作" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="handleRowWenJuan(scope.row)" v-has="'progress_ckwj'">查看问卷</el-button>
                            <el-button type="text" size="mini" @click="handleJianKang(scope.row)" v-has="'progress_ckda'">查看档案</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <data-form :visible="dialogVisible" :localForm="form" @close="dialogVisible = false"
                   @update="getData" :idList="idList"></data-form>
        <datawg-form :visible="dialogVisiblewg"  @close="dialogVisiblewg = false"
                   @update="getData" ref="dataform"></datawg-form>
        <div class="pager" v-if="table.total > table.pageSize">
            <el-pagination layout="total, prev, pager, next, sizes"
                           :page-sizes="[10, 20, 30, 50, 100, 200, 500, 1000]"
                           :current-page="table.page" :total="table.total" :page-size="table.pageSize"
                           @current-change="handlePageChange" @size-change="handlePageSizeChange"/>
        </div>
    </div>
</template>

<script>
    import data from './data'
    import formatter from "../../data/formatter"
    import {dbList, dwList, grList, pgList} from "../../data/utlisData"
    import dataForm from "../hi/widgets/dataForm";
    import datawgForm from "./widgets/datawgForm";
    import CascaderCompanyName from "../../components/form/cascaderCompanyName";

    const makeInitSearch = () => {
        return {
            companyName: "",
            key: "name",
            value: "",
            reportType: "",
            reportTime: [],
            risklevelList: [],
            level: "",
            risklevel: ""
        }
    }


    export default {
        name: 'phr',
        components: {
            CascaderCompanyName,
            dataForm,
            datawgForm
        },
        data() {
            return {
                dialogVisiblewg: false,
                gzqList: [],
                dbList: dbList,
                defaultProps: {
                    multiple: true,
                    children: 'tags',
                    label: 'name',
                    value: 'value',
                    emitPath: false
                },
                data: {},
                isFullIdCard: {},
                tagList: [
                    {
                        id: 3,
                        name: "三级"
                    },
                    {
                        id: 2,
                        name: "二级"
                    },
                    {
                        id: 1,
                        name: "一级"
                    },
                ],
                form: {},
                dialogVisible: false,
                formatter: formatter,
                dwList: dwList,
                grList: grList,
                pgList: pgList,
                loading: false,
                search: makeInitSearch(),
                table: data.table,
                idList: []
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                if(from.path.indexOf("/main/phr/detail/")>-1){
                    vm.handlePopState()
                }
            });
        },
        methods: {
            handleSendQuestionnaire() {
                this.$confirm(`确认要发送五高问卷吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true
                    this.$http.post(`/wenjuan/send`, {userIdList: this.idList})
                        .then(resp => {
                            this.$message[resp.data.status](resp.data.msg)
                            if (resp.data.status == 'success') this.getData()
                        }).catch(err => {
                        this.$message.error(err.message)
                    }).finally(() => {
                        this.loading = false
                    })
                }).catch(() => {
                });
            },
            handleRowWenJuan(row) {
                this.$refs.dataform.getData(row.id);
                this.dialogVisiblewg = true
            },
            handleJianKang(row) {
                this.$router.push({path: `/main/phr/detail/${row.id}`})
            },
            handlePopState() {
                const savedConditions = localStorage.getItem('searchConditions');
                const black = localStorage.getItem('back');
                if (savedConditions && black) {
                    this.search = JSON.parse(savedConditions);
                }
            },
            handelRadio() {
                this.search.evalTags = []
                this.search.grTagList = []
            },
            handelNode() {
                var tagList = []
                this.$refs.tree.getCheckedNodes().forEach(function (item) {
                    tagList.push(item.name)
                })
                this.search.evalTags = tagList
                this.getData()
            },
            maskIdCardRegex(idCard) {
                return idCard.replace(/^(.{4})(.*)(.{4})$/, function (match, p1, p2, p3) {
                    return p1 + p2.replace(/./g, '*') + p3;
                });
            },
            toggleIdCard(index) {
                // 切换显示状态
                this.$set(this.isFullIdCard, index, !this.isFullIdCard[index]);
            },
            handleAdd() {
                this.form = {
                    plans: [],
                    healthGuidance: {},
                    image: [],
                    video: [],
                    supplementContent: {}
                }
                this.dialogVisible = true
            },
            handleReminder() {
                this.$message({
                    message: '开发中',
                    type: 'info'
                });
            },
            reset() {
                this.search = makeInitSearch()
                setTimeout(() => {
                    this.getData()
                    localStorage.removeItem('searchConditions');
                    localStorage.removeItem('back');
                }, 0);
            },
            handleSelectionChange(val) {
                var that = this
                that.idList = val
            },
            handlePageChange(e) {
                this.table.page = e
                this.getData()
            },
            handlePageSizeChange(e) {
                this.table.pageSize = e
                this.getData()
            },
            async getData() {
                this.dialogVisible = false
                this.loading = true
                this.search.page = this.table.page
                this.search.pageSize = this.table.pageSize
                const resp = await this.$http.post(`/wenjuan/fg/`, this.search)
                if (!resp.data) {
                    this.$message.error(resp.data.msg)
                } else {
                    this.table.data = resp.data.data
                    this.table.total = resp.data.total
                    localStorage.setItem('searchConditions',JSON.stringify(this.search));
                }
                this.loading = false
            },
        },
        mounted() {
            this.getData()
        }
    }
</script>

<style lang="scss" scoped>
    .page {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .header {
        padding-bottom: 10px;

        .btns {
            float: right;
        }
    }

    .search {
        padding: 10px;
        background-color: #FAFAFA;
        border-top: 1px solid #EBEEF5;
        border-left: 1px solid #EBEEF5;
        border-right: 1px solid #EBEEF5;

        ::v-deep .el-form-item {
            padding: 5px 0 !important;
            margin-bottom: 5px !important;
        }

        .btns {
            float: right;
        }
    }

    .main-content {
        flex: 1;
        position: relative;
    }

    .table-content {
        position: absolute;
        width: 100%;
        height: 100%;
    }

    .pager {
        padding-top: 10px;
        text-align: center;
    }
</style>
